export const reportShipmentsReturnsTypes = {
  SET_SHIPMENTS_RETURNS_FILTERS: 'REPORT_SHIPMENTS_RETURNS/SET_FILTERS',
  RESTORE_INITIAL: 'REPORT_SHIPMENTS_RETURNS/RESTORE_INITIAL'
};
